export const productFrontendPath = '/product';
export const productBackendPath = '/backend/product/';
export const productCreateFrontendPath = '/product/create';
export const productCreateBackendPath = '/backend/product/create/';
export const productEditFrontendPath = '/product/:id';
export const productEditBackendPath = '/backend/product/edit/';

export const machineLendingFrontendPath = '/machine/lending';
export const machineLendingBackendPath = '/backend/product/machine/lending/';
export const machineLendingCreateFrontendPath = '/machine/lending/create';
export const machineLendingCreateBackendPath = '/backend/product/machine/lending/create/';
export const machineLendingEditFrontendPath = '/machine/lending/:id';
export const machineLendingEditBackendPath = '/backend/product/machine/lending/edit/';
export const machineLendingExtendFrontendPath = '/machine/lending/extend/:id';
export const machineLendingExtendBackendPath = '/backend/product/machine/lending/extend/';
export const machineLendingBatchExtentFrontendPath = '/machine/lending/batch_extent';
export const machineLendingBatchExtentBackendPath = '/backend/product/machine/lending/batch_extent/';
export const machineLendingReturnFrontendPath = '/machine/lending/return/:id';
export const machineLendingReturnBackendPath = '/backend/product/machine/lending/return/';

export const productOrderFrontendPath = '/order/product/';
export const productOrderBackendPath = '/backend/product/order/';

export const promotionFrontendPath = '/promotion';
export const promotionBackendPath = '/backend/product/promotion/';
export const promotionCreateFrontendPath = '/promotion/create';
export const promotionEditFrontendPath = '/promotion/:id';
export const promotionEditBackendPath = '/backend/product/promotion/';
export const promotionBenefitBackendPath = '/backend/product/promotion/benefit/';
export const promotionTriggerBackendPath = '/backend/product/promotion/trigger/';

export const appSubscriptionFrontendPath = '/app_subscription';
export const appSubscriptionBackendPath = '/backend/product/app/subscription/';
export const appSubscriptionExtendFrontendPath = '/app_subscription/extend/:id';
export const appSubscriptionExtendBackendPath = '/backend/product/app/subscription/extend/';
export const appSubscriptionAdjustFrontendPath = '/app_subscription/adjust/:id';
export const appSubscriptionAdjustBackendPath = '/backend/product/app/subscription/expiry/adjust/';
export const appSubscriptionUpdateFrontendPath = '/app_subscription/update/:id';
export const appSubscriptionUpdateBackendPath = '/backend/product/app/subscription/update';

export const paymentTypeBackendPath = '/backend/product/payment_type/';



// WEBPACK FOOTER //
// ./src/routes/product/urls.js